<script>
  export let additionalPhoneNumbers = [];
  export let deleteNumber = () => {};
  export let addNumber = () => {};

  let newNumberOwner;
  let newNumberNumber;
</script>

<div class="col table-responsive" style="height: 400px; overflow: scroll;">
  <label for="newNumber" class="form-label">İletişim Bilgileri</label>
  <div class="d-flex flex-row justify-content-center">
    <input
      type="text"
      class="form-control text-center"
      placeholder="Numaranın Sahibi"
      bind:value={newNumberOwner}
    />
    <input
      type="text"
      class="form-control text-center"
      placeholder="Telefon Numarası"
      bind:value={newNumberNumber}
    />
  </div>
  <div class="text-center">
    <button
      on:click|preventDefault={addNumber(
        newNumberOwner + '-' + newNumberNumber
      )}
      class="btn btn-success mt-2">Ekle</button
    >
  </div>
  <table class="table-sm">
    <thead>
      <tr>
        <th class="w-50">Numaranın Sahibi</th>
        <th class="w-50">Telefon Numarası</th>
        <th class="w-25">İşlemler</th>
      </tr>
    </thead>
    <tbody>
      {#each additionalPhoneNumbers as number}
        <tr>
          <td class="w-50"
            ><input
              type="text"
              class="form-control"
              bind:value={number.owner}
            />
          </td>
          <td class="w-50"
            ><input
              type="text"
              class="form-control"
              bind:value={number.phoneNumber}
            /></td
          >
          <td class="w-25">
            <button
              on:click|preventDefault={deleteNumber(number._id)}
              class="btn btn-danger">Sil</button
            ></td
          >
        </tr>
      {/each}
    </tbody>
  </table>
</div>
